import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import { L as Label, I as Input } from './TileToggleArea.styles-099dc078.js';

const TileToggleArea = /*#__PURE__*/forwardRef(({
  checked,
  children,
  disabled,
  focusProps,
  label,
  multiple,
  name,
  onChange,
  value,
  className,
  ...restProps
}, ref) => /*#__PURE__*/React__default.createElement(Label, {
  htmlFor: label,
  disabled: disabled,
  $active: checked,
  className: className
}, /*#__PURE__*/React__default.createElement(Input, _extends({}, restProps, {
  focusProps: focusProps,
  ref: ref,
  id: label,
  type: multiple ? 'checkbox' : 'radio',
  checked: checked,
  "aria-checked": checked,
  disabled: disabled,
  name: name,
  value: value,
  onChange: onChange
})), children));
var TileToggleArea$1 = TileToggleArea;

export { TileToggleArea$1 as T };
//# sourceMappingURL=TileToggleArea-215b02fa.js.map
